const wait = (ms) => new Promise((resolve) => {
    setTimeout(resolve, ms)
})

const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
})

const truncateId = (text, size = 4) => {
    if (!text) return undefined
    return `${text.slice(0, size)}...${text.slice(-1 * size)}`
}

export default () => ({
    wait,
    toBase64,
    truncateId,
})
